export const checkIsVerified = (anketaStatuses) =>
  !!(anketaStatuses && anketaStatuses.hasVerifiedPhoto)
